import { useAtom } from 'jotai';
import { memo, useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useActionEmailData } from '@/src/modules/CampaignsModule/hooks/useActionEmailData';

import { htmlEditorActionDisabledAtom } from './atoms/htmlEditorAtom';
import { ModalUpload } from './components/ModalUpload/ModalUpload';
import ModalValidateHTML from './components/ModalValidateHTML/ModalValidateHTML';
import { useModalValidate } from './hooks/useModalValidate';
import EditPage from './pages/EditPage';
import HeaderSection from './HeaderSection';

import { useHiddenV1Container } from '@/modules/AutomationModuleNew/hooks/useHiddenV1Container';

interface IHtmlEditorProps {
  isAutomationModule?: boolean;
}

const HtmlEditor = memo(({ isAutomationModule = false }: IHtmlEditorProps) => {
  useHiddenV1Container();
  const { actionId } = useParams();
  // const { action: actionData, loading: actionDataIsLoading } = useActionData(Number(actionId));

  const { isOpen, data, setIsOpen, setData } = useModalValidate();
  const [disabled, setDisabled] = useAtom(htmlEditorActionDisabledAtom);

  const { getEmailInfo } = useActionEmailData(Number(actionId));

  const handleOnClose = useCallback(() => {
    setIsOpen(false);
    setData({ errors: [], warnings: [] });
  }, [setIsOpen, setData]);

  useEffect(() => {
    void getEmailInfo();
  }, [getEmailInfo, setDisabled]);

  useEffect(() => {
    return () => {
      setDisabled(true);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-[calc(100vh_-_64px)] bg-emblue-white">
      <HeaderSection disabled={disabled} isAutomationModule={isAutomationModule} />
      <div className="p-10">
        <EditPage />
      </div>
      <ModalUpload />
      <ModalValidateHTML data={data} isOpen={isOpen} onClose={handleOnClose} />
    </div>
  );
});

export default HtmlEditor;
